import { useState, useEffect } from "react";
import Logo from "../../assets/images/logo.svg";
import { IconChartLine } from "@tabler/icons-react";
import { IconIndentDecrease } from "@tabler/icons-react";
import Button from "react-bootstrap/Button";
const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.classList.add("sidebar-open");
    } else {
      document.body.classList.remove("sidebar-open");
    }
  }, [isSidebarOpen]);

  return (
    <div className="sidebar">
      {/* sidebar button */}
      {/* <Button variant="link" className='p-0 close-sidebar-btn' onClick={toggleSidebar} title='Collapse Sidebar'>
        <IconIndentDecrease color='currentColor' size={18} />
      </Button> */}
      {/* logo-part */}
      <div className="logo-part">
        <a href="#">
          <img src={Logo} alt="Trust Evel" title="Trust Evel" />
        </a>
      </div>
      <nav className="sidebar-nav">
        <ul>
          <li className="sidebar-nav-link">
            <a href="#" title="Reports">
              <IconChartLine color="currentColor" size={22} />
              Reports
            </a>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
